export default __webpack_public_path__ + "static/media/idr-icon-id-yellow.840efd50.svg";